// eslint-disable-next-line
import React from 'react';
import {
    ListItemText,
    Typography,
} from '@mui/material';
import * as PXBColors from '@brightlayer-ui/colors';
import { TooltipItem } from '../TooltipItem/TooltipItem';
import { getControlledText } from '../../app/enum/GenericFormat';

export const UserDetailsListItem: React.FC<React.PropsWithChildren<React.PropsWithChildren<{
    title: string;
    value: string;
    testid?: string;
    size?: number;
}>>> = (props) => {
    return (
        <ListItemText>
            <TooltipItem
                title={props.value}
                isTopPlacement={true}
                lenghtLimit={50}
                component={
                    <Typography data-testid={props.testid} style={{ paddingLeft: 16, fontWeight: 600, fontSize: props.size ? props.size : 16, lineHeight: 2, fontStyle: 'normal', color: PXBColors.black[500] }}  >
                        {getControlledText(props.value, 50)}
                    </Typography>
                }>
            </TooltipItem>

            <Typography style={{ paddingLeft: 16, fontWeight: 400, fontSize: 14, lineHeight: 1, color: PXBColors.gray[500] }}>{props.title}</Typography>
        </ListItemText>
    );
};
